var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.showHeader)?_c('LayoutHeader',{staticClass:"layout--header"}):_vm._e(),_c('LayoutContent',{staticClass:"layout--content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }